module.exports = __webpack_public_path__ + "static/media/loader_gif_fisdom.7d2ebd03.gif";